import { Injectable, ComponentRef, ApplicationRef, ComponentFactoryResolver, Injector, EmbeddedViewRef, Type } from '@angular/core';
import { ToastComponent } from './toast.component';
import { ToastType } from './toast.component';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastComponentRef: ComponentRef<ToastComponent> | null = null;

  constructor(
    private appRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector
  ) {}

  private createToastComponent(): ComponentRef<ToastComponent> {
    const componentRef = this.componentFactoryResolver
      .resolveComponentFactory(ToastComponent)
      .create(this.injector);
    
    // 将组件添加到 DOM
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    // 将组件附加到应用程序引用
    this.appRef.attachView(componentRef.hostView);

    return componentRef;
  }

  private showToast(message: string, type: ToastType, duration: number = 3000): void {
    // 如果已经存在 toast，先移除它
    this.hideToast();

    // 创建新的 toast
    this.toastComponentRef = this.createToastComponent();
    
    // 设置 toast 属性
    const instance = this.toastComponentRef.instance;
    instance.message = message;
    instance.type = type;
    instance.duration = duration;
    instance.visible = true;

    // 监听 visible 变化，当 toast 隐藏时清理组件
    const subscription = instance['visibleChange']?.subscribe((visible: boolean) => {
      if (!visible) {
        this.hideToast();
        subscription?.unsubscribe();
      }
    });

    // 设置定时器自动隐藏
    setTimeout(() => {
      if (this.toastComponentRef) {
        instance.visible = false;
      }
    }, duration);
  }

  private hideToast(): void {
    if (this.toastComponentRef) {
      this.appRef.detachView(this.toastComponentRef.hostView);
      this.toastComponentRef.destroy();
      this.toastComponentRef = null;
    }
  }

  success(message: string, duration?: number): void {
    this.showToast(message, 'success', duration);
  }

  error(message: string, duration?: number): void {
    this.showToast(message, 'error', duration);
  }
}
